import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, Typography } from '@material-ui/core';

// UTILITY
import { customAnalyticsEvent } from '@/utility/analytics';

const DialogAlert = ({ actionName, text, partner, partner_id, ...props }) => {
  useEffect(() => {
    customAnalyticsEvent(actionName, {
      partner: partner?.slug || '',
      partner_id,
    });
  }, []);

  return (
    <Dialog {...props}>
      <DialogContent>
        <Typography className="m-b-10" variant="body1">
          {text}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

DialogAlert.defaultProps = {
  actionName: 'Local Storage Error',
};

DialogAlert.propTypes = {
  actionName: PropTypes.string,
  text: PropTypes.string.isRequired,
  partner: PropTypes.object.isRequired,
  partner_id: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
};

export default React.memo(DialogAlert);
